export enum AttendType {
  Normal = 0,
  Agent = 1,
}
